import { useState } from "react";

import { SearchUser } from "~/components/v2/users/SearchUser";
import UserLink from "../../users-components/UserLink";
import { Button } from "../../themed/Button";
import { Prisma } from "@prisma/client";
import { api } from "~/utils/api";
import { CommunityPage } from "~/types/CommunityTypes";
import { useRouter } from "next/navigation";
import { toast } from "react-toastify";

interface Props {
    community: CommunityPage;
    refetch?: () => void;
}

const EditOrganizers = ({ community, refetch }: Props) => {
    const router = useRouter();
    const [selectedOrganizer, setSelectedOrganizer] =
        useState<Prisma.UserGetPayload<{
            select: {
                id: true;
                name: true;
                email: true;
            };
        }> | null>(null);
    const [query, setQuery] = useState<string>("");

    const { data: users } = api.user.searchUsers.useQuery(
        {
            slug: community?.slug,
            searchQuery: query,
        },
        {
            enabled: !!community,
        },
    );

    const updateCommunity = api.community.updateCommunity.useMutation();

    const handleEditOrganizer = (emailToDete?: string | null) => {
        if (!community) return;
        const onSuccess = {
            onSuccess: () => {
                setSelectedOrganizer(null);
                refetch?.();
                router.refresh();
                toast.success("Organizer updated successfully");
            },
        };
        if (emailToDete) {
            updateCommunity.mutateAsync(
                {
                    slug: community.slug,
                    organizer: {
                        email: emailToDete,
                        remove: true,
                    },
                },
                onSuccess,
            );
        }

        if (selectedOrganizer && selectedOrganizer.email) {
            updateCommunity.mutateAsync(
                {
                    slug: community.slug,
                    organizer: {
                        email: selectedOrganizer.email,
                    },
                },
                onSuccess,
            );
        }
    };

    return (
        <div className="flex flex-col gap-2">
            <h6>Organizers</h6>
            {community?.leaders?.map((h) => (
                <div
                    className="flex w-full max-w-[350px] gap-4"
                    key={`organizer-host-${h.id}`}
                >
                    <UserLink user={h} />
                    <Button
                        className="w-[100px] rounded"
                        variant="destructive"
                        onClick={() => handleEditOrganizer(h.email)}
                    >
                        Remove
                    </Button>
                </div>
            ))}
            <div className="mt-4 flex w-full max-w-[350px] flex-col gap-4">
                <SearchUser
                    users={users}
                    placeholder="Search for a person"
                    setQuery={setQuery}
                    selected={selectedOrganizer}
                    setSelected={setSelectedOrganizer}
                />
                <Button
                    className="rounded"
                    onClick={() => handleEditOrganizer()}
                >
                    Add
                </Button>
            </div>
        </div>
    );
};

export default EditOrganizers;
